import React from "react";
import { useCountdown } from "../hooks/useCountdown";

/** Days, hours and minutes until `target`. */
const Countdown: React.FC<{ target: string }> = ({ target }) => {
  const { days, hours, minutes, done } = useCountdown(target);
  if (done) return null;
  const cells: Array<[number, string]> = [
    [days, days === 1 ? "day" : "days"],
    [hours, hours === 1 ? "hour" : "hours"],
    [minutes, minutes === 1 ? "min" : "mins"],
  ];
  return (
    <div className="gm-countdown" role="timer" aria-label={`${days} days, ${hours} hours, ${minutes} minutes to go`}>
      {cells.map(([n, unit]) => (
        <div className="gm-countdown__cell" key={unit}>
          <span className="gm-countdown__num">{n}</span>
          <span className="gm-countdown__unit">{unit}</span>
        </div>
      ))}
    </div>
  );
};

export default Countdown;
